<template>
    <!--Social Links Section-->
    <div id="social-links">
        <div class="marketing-main-container">
            <div class="marketing-wrapper">
                <div class="marketing-heading">
                    <h3>{{ $t("marketing.socialLinks") }}</h3>
                    <div class="font-italic">
                        {{ $t("marketing.socialLinksContent") }}
                    </div>
                </div>
                <div v-if="!loading" class="marketing-content section-wrap">
                    <!--Website-->
                    <div class="push-notifications-wrapper highlighted-box section-wrap">
                        <div class="socials-container">
                            <div class="gentle-hover-shake">
                                <label for="website"><i class="social-icon website-icon"></i></label>
                            </div>

                            <div class="socials-content">
                                <div class="socials-heading">
                                    <label for="website" class="social-label">
                                        {{ $t("marketing.website") }}
                                    </label>
                                    <div class="button-test">
                                        <div>
                                            <a target="_blank" class="primary-btn extra-small"
                                                :href="normalizeUrl(websiteUrl)">{{
                                                    $t("marketing.testLink")
                                                }}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="social-input-wrap">
                                    <input id="website" type="text" class="text-field" placeholder="Website URL"
                                        v-model="websiteUrl" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Youtube-->
                    <div class="push-notifications-wrapper highlighted-box section-wrap">
                        <div class="socials-container">
                            <div class="gentle-hover-shake">
                                <label for="youtube"><i class="social-icon youtube fa fa-youtube-square"></i></label>
                            </div>
                            <div class="socials-content">
                                <div class="socials-heading">
                                    <label for="facebook" class="social-label">
                                        {{ $t("marketing.youtube") }}
                                    </label>
                                    <div class="button-test">
                                        <div>
                                            <a target="_blank" class="primary-btn extra-small"
                                                :href="normalizeUrl(youtubeUrl)">{{
                                                    $t("marketing.testLink")
                                                }}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="social-input-wrap">
                                    <input id="youtube" type="text" class="text-field" placeholder="Youtube URL"
                                        v-model="youtubeUrl" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Facebook-->
                    <div class="push-notifications-wrapper highlighted-box section-wrap">
                        <div class="socials-container">
                            <div class="gentle-hover-shake">
                                <label for="facebook"><i class="social-icon facebook fa fa-facebook-square"></i></label>
                            </div>
                            <div class="socials-content">
                                <div class="socials-heading">
                                    <label for="facebook" class="social-label">
                                        {{ $t("marketing.facebook") }}
                                    </label>
                                    <div class="button-test">
                                        <div>
                                            <a target="_blank" class="primary-btn extra-small"
                                                :href="normalizeUrl(facebookUrl)">{{
                                                    $t("marketing.testLink")
                                                }}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="social-input-wrap">
                                    <input id="facebook" type="text" class="text-field" placeholder="Facebook URL"
                                        v-model="facebookUrl" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Instagram-->
                    <div class="push-notifications-wrapper highlighted-box section-wrap">
                        <div class="socials-container">
                            <div class="gentle-hover-shake">
                                <label for="instagram"><i class="social-icon instagram fa fa fa-instagram"></i></label>
                            </div>
                            <div class="socials-content">
                                <div class="socials-heading">
                                    <label for="instagram" class="social-label">
                                        {{ $t("marketing.instagram") }}
                                    </label>
                                    <div class="button-test">
                                        <div>
                                            <a target="_blank" class="primary-btn extra-small"
                                                :href="normalizeUrl(instagramUrl)">{{
                                                    $t("marketing.testLink")
                                                }}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="social-input-wrap">
                                    <input id="instagram" type="text" class="text-field" placeholder="Instagram URL"
                                        v-model="instagramUrl" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Yelp-->
                    <div class="push-notifications-wrapper highlighted-box section-wrap">
                        <div class="socials-container">
                            <div class="gentle-hover-shake">
                                <label for="yelp"><i class="social-icon yelp fa fa fa-yelp"></i></label>
                            </div>
                            <div class="socials-content">
                                <div class="socials-heading">
                                    <label for="yelp" class="social-label">
                                        {{ $t("marketing.yelp") }}
                                    </label>
                                    <div class="button-test">
                                        <div>
                                            <a target="_blank" class="primary-btn extra-small"
                                                :href="normalizeUrl(yelpUrl)">{{
                                                    $t("marketing.testLink")
                                                }}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="social-input-wrap">
                                    <input id="yelp" type="text" class="text-field" placeholder="Yelp URL"
                                        v-model="yelpUrl" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Twitter-->
                    <div class="push-notifications-wrapper highlighted-box section-wrap">
                        <div class="socials-container">
                            <div class="gentle-hover-shake">
                                <label for="twitter"><i class="social-icon twitter fa fa fa-twitter-square"></i></label>
                            </div>
                            <div class="socials-content">
                                <div class="socials-heading">
                                    <label for="twitter" class="social-label">
                                        {{ $t("marketing.twitter") }}
                                    </label>
                                    <div class="button-test">
                                        <div>
                                            <a target="_blank" class="primary-btn extra-small"
                                                :href="normalizeUrl(twitterUrl)">{{
                                                    $t("marketing.testLink")
                                                }}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="social-input-wrap">
                                    <input id="twitter" type="text" class="text-field" placeholder="Twitter URL"
                                        v-model="twitterUrl" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Tiktok-->
                    <div class="push-notifications-wrapper highlighted-box section-wrap">
                        <div class="socials-container">
                            <div class="gentle-hover-shake">
                                <label for="tiktok"><img class="tiktok-img" src="../../assets/images/tiktok.png"
                                        width="100" /></label>
                            </div>
                            <div class="socials-content">
                                <div class="socials-heading">
                                    <label for="tiktok" class="social-label">
                                        {{ $t("marketing.tik_tok") }}
                                    </label>
                                    <div class="button-test">
                                        <div>
                                            <a target="_blank" class="primary-btn extra-small"
                                                :href="normalizeUrl(tiktokUrl)">{{
                                                    $t("marketing.testLink")
                                                }}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="social-input-wrap">
                                    <input id="tiktok" type="text" class="text-field" placeholder="Tik Tok URL"
                                        v-model="tiktokUrl" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="action-buttons-wrap">
                        <div>
                            <button type="button" class="primary-btn extra-small" v-on:click="saveProfile">
                                {{ $t("marketing.save") }}
                            </button>
                        </div>
                    </div>
                </div>

                <MainLoader v-if="loading" class="section-wrap" />
            </div>
        </div>
    </div>
</template>

<script>
import api from "../../services/apiEndpoints.js";
import messages from "./../../services/messages.js";
import auth from "../../services/auth.js";
import eventBus from "../../services/eventBus.js";

import MainLoader from "./general-components/MainLoader.vue";

export default {
    name: "SocialLinks",

    data() {
        return {
            youtubeUrl: "",
            facebookUrl: "",
            instagramUrl: "",
            yelpUrl: "",
            twitterUrl: "",
            websiteUrl: "",
            tiktokUrl: "",
            loading: false,
        };
    },
    computed: {
        adminDetails: {
            get: function () {
                return this.$store.state.adminDetails;
            },
            set: function (value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
    },
    mounted: function () {
        this.user = auth.state.user;

        //check if adminDetails are either in store or loaded
        //if yes then do necessary logic
        if (this.$store.state.adminDetails.user) {
            this.populateSocialUrls();
        } else {
            this.getStylistDetails();
        }
        let self = this;
        eventBus.on("admin_details_loaded", function () {
            self.populateSocialUrls();
        });
    },
    methods: {
        saveProfile: function () {
            if (!this.validateSocialLinks()) {
                return;
            }

            let data = {
                links: true,
                facebook_url: this.facebookUrl,
                youtube_url: this.youtubeUrl,
                instagram_url: this.instagramUrl,
                yelp_url: this.yelpUrl,
                tiktok_url: this.tiktokUrl,
                twitter_url: this.twitterUrl,
                website: this.websiteUrl,
            };

            this.saveProfileInProgress = true;
            this.$http.post(api.actions.save_profile_info, data).then(
                function (response) {
                    this.saveProfileInProgress = false;
                    if (response.data.error == false) {
                        messages.successMessage(messages.GLOBAL_MESSAGES.SOCIAL_LINKS_SAVED);
                        this.getStylistDetails();
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },

        getStylistDetails: function () {
            this.loading = true;

            this.$http.get(api.actions.get_stylist_details + this.user.id)
                .then((response) => {
                    if (typeof response.data.details !== "undefined") {
                        let adminDetails = response.data.details;
                        this.$store.commit("setAdminDetails", adminDetails);
                        eventBus.emit("admin_details_loaded");
                    }
                })
                .catch((error) => {
                    console.error("Request failed:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        populateSocialUrls: function () {
            this.facebookUrl = this.adminDetails.profile.facebook_url;
            this.instagramUrl = this.adminDetails.profile.instagram_url;
            this.yelpUrl = this.adminDetails.profile.yelp_url;
            this.twitterUrl = this.adminDetails.profile.twitter_url;
            this.tiktokUrl = this.adminDetails.profile.tiktok_url;
            this.youtubeUrl = this.adminDetails.profile.youtube_url;
        },

        validateSocialLinks() {
            const validators = {
                facebook_url: {
                    value: this.facebookUrl,
                    domains: ['facebook.com', 'fb.com']
                },
                youtube_url: {
                    value: this.youtubeUrl,
                    domains: ['youtube.com', 'youtu.be']
                },
                instagram_url: {
                    value: this.instagramUrl,
                    domains: ['instagram.com']
                },
                yelp_url: {
                    value: this.yelpUrl,
                    domains: ['yelp.com']
                },
                tiktok_url: {
                    value: this.tiktokUrl,
                    domains: ['tiktok.com']
                },
                twitter_url: {
                    value: this.twitterUrl,
                    domains: ['twitter.com', 'x.com']
                },
                website: {
                    value: this.websiteUrl,
                    domains: [] // any valid website
                }
            };

            for (let key in validators) {
                let { value, domains } = validators[key];

                if (!value) continue;

                // Normalize copied links like "www.youtube.com"
                value = this.normalizeUrl(value);

                // Website: allow any valid URL
                if (domains.length === 0) {
                    try {
                        new URL(value);
                    } catch {
                        messages.errorMessage('Invalid website URL');
                        return false;
                    }
                    continue;
                }

                if (!this.isValidPlatformUrl(value, domains)) {
                    messages.errorMessage(
                        `Invalid ${key.replace('_url', '')} link`
                    );
                    return false;
                }
            }

            return true;
        },

        normalizeUrl(url) {
            // If it already has a protocol, leave it alone
            if (/^https?:\/\//i.test(url)) {
                return url;
            }

            // Otherwise, assume https
            return `https://${url}`;
        },

        isValidPlatformUrl(url, allowedDomains) {
            if (!url) return true; // allow empty

            try {
                const parsedUrl = new URL(url);
                return allowedDomains.some(domain =>
                    parsedUrl.hostname.includes(domain)
                );
            } catch (e) {
                return false; // invalid URL format
            }
        },

    },

    components: {
        MainLoader,
    },
};
</script>
